export enum DatabaseType {
    Legacy = 'legacy',
    Tablesdb = 'tablesdb',
    Documentsdb = 'documentsdb',
    Vectorsdb = 'vectorsdb',
    Mysql = 'mysql',
    Postgresql = 'postgresql',
    Mongodb = 'mongodb',
}
